import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  active_sidebar: true,
  categorty: 'all',
  selectedAggregator: 'all',

};

const changeMenuStateSlice = createSlice({
  name: 'sidebar',
  initialState: initialState,
  reducers: {
    toggleSidebar: (state, action) => {

      if (state.active_sidebar == true) {
        state.active_sidebar = false
      } else {
        state.active_sidebar = true
      }
    },
    selectCategory: (state, action) => {
      state.categorty = action.payload || 'all';
    },
    selectAggregator: (state, action) => {
      state.selectedAggregator = action.payload || 'all';
    },
    removeCategoryDetails: (state, action) => {
      state.categorty = "all";
    }
  }
});

export const { toggleSidebar, selectCategory, selectAggregator, removeCategoryDetails } = changeMenuStateSlice.actions;

export default changeMenuStateSlice.reducer;